import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling  } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { TitleStrategy } from '@angular/router';
import { SeoTitleStrategy } from './core/seo/seo-title-strategy';
// import { provideServerRendering } from '@angular/platform-server';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ), 
    provideClientHydration(withEventReplay()),
    // provideServerRendering(),
    { provide: TitleStrategy, useClass: SeoTitleStrategy }
  ]
};
